var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptocurrency01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8779 20.0902C16.1694 21.3315 14.1118 22 12 22C9.88824 22 7.83066 21.3315 6.12218 20.0902M16.3837 3.01206C18.2818 3.93781 19.8381 5.44068 20.8295 7.30528C21.8209 9.16989 22.1966 11.3005 21.9027 13.3917M2.09745 13.3916C1.80355 11.3004 2.17923 9.16979 3.17066 7.30519C4.16208 5.44059 5.71836 3.93771 7.61642 3.01196M17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96247 17.5 6.50004 15.0376 6.50004 12C6.50004 8.96244 8.96247 6.5 12 6.5C15.0376 6.5 17.5 8.96244 17.5 12Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency01);
export default __webpack_public_path__ + "static/media/cryptocurrency-01.ff5bbbeba79788173e2a814fea93d042.svg";
export { ForwardRef as ReactComponent };